<div class="filter-drawer">

    <!-- HEADER -->
    <div class="filter-header" [class.type2]="type == 2" *ngIf="!url.includes('createCampaignTemplate')">
        <!-- HEADER TYPE 2 (Blue Strip) -->
        <ng-container *ngIf="type == 2">
            <span class="header-text">Filters</span>
            <mat-icon [attr.guide]="'filter-popup-btn-close' + '__' + sanitizeUrl(url)"
                style="cursor: pointer; color: white;" (click)="callclosepopup()"
                matTooltip="Close Filters">close</mat-icon>
        </ng-container>

        <!-- HEADER TYPE 1 (Modern White) -->
        <ng-container *ngIf="type != 2">
            <div class="title-area">
                <mat-icon color="primary">filter_alt</mat-icon>
                <span>Filters</span>
            </div>
            <button (click)="callclosepopup()" mat-icon-button class="close-btn" matTooltip="Close Filters"
                [attr.guide]="'btn-lead-view-close' + '__' + sanitizeUrl(url)">
                <mat-icon>close</mat-icon>
            </button>
        </ng-container>
    </div>

    <!-- BODY -->
    <div class="filter-scroll-body">
        <div class="form-section">
            <ng-container *ngFor="let filter of filterSelectObj; let i=index;">
                <ng-container *ngIf="filter.type != 'disable'">

                    <!-- SHARED FORM FIELD STRUCTURE -->
                    <mat-form-field appearance="outline" class="premium-field"
                        *ngIf="(!columns || !columns[i] || columns[i].visible) && filter.type != 'date'">
                        <mat-label>{{filter.name | uppercase}}</mat-label>

                        <!-- Prefix icons ONLY for Type 1 -->
                        <mat-icon *ngIf="type != 2" matPrefix color="primary" [ngSwitch]="filter.name.toLowerCase()">
                            <ng-container *ngSwitchCase="'status'">check_circle</ng-container>
                            <ng-container *ngSwitchCase="'status name'">check_circle</ng-container>
                            <ng-container *ngSwitchCase="'lead status'">check_circle</ng-container>
                            <ng-container *ngSwitchCase="'life stage'">check_circle</ng-container>
                            <ng-container *ngSwitchCase="'active'">toggle_on</ng-container>
                            <ng-container *ngSwitchCase="'active status'">toggle_on</ng-container>
                            <ng-container *ngSwitchCase="'owner'">person</ng-container>
                            <ng-container *ngSwitchCase="'created by'">person_add</ng-container>
                            <ng-container *ngSwitchCase="'tracker name'">label</ng-container>
                            <ng-container *ngSwitchCase="'description'">description</ng-container>
                            <ng-container *ngSwitchCase="'country'">public</ng-container>
                            <ng-container *ngSwitchCase="'created date'">event</ng-container>
                            <ng-container *ngSwitchCase="'updated date'">update</ng-container>
                            <ng-container *ngSwitchCase="'type of service'">payments</ng-container>
                            <ng-container *ngSwitchCase="'activity type'">local_activity</ng-container>
                            <ng-container *ngSwitchDefault>label_important</ng-container>
                        </mat-icon>

                        <!-- Multi-Select Logic -->
                        <mat-select [(ngModel)]="selectedValues[i]" [compareWith]="compareOption"
                            (selectionChange)="filterColumnMultiSelect($event,i,filter.type)" multiple
                            [disableOptionCentering]="true"
                            *ngIf="filter.type == 'multiSelect' || filter.type == 'multiselect'">
                            <ngx-mat-select-search *ngIf="showSearchForFilter(filter)" [formControl]="filterSearchControls[i]" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                            <ng-container
                                *ngIf="!url.includes('whatsAppBotFlows') && !url.includes('leadMeetingSummaryReport') && !url.includes('botRepliesList') && !url.includes('expenseCategories') && !url.includes('posPurchase') && !url.includes('holidays') ">
                                <ng-container *ngIf="filter.property == 'a.status' || filter.name == 'Status'">
                                    <ng-container
                                        *ngIf="filter.property == 'status' && filteredTaskStatusTypeList?.length > 0">
                                        <mat-option
                                            *ngFor="let opt of filteredTaskStatusTypeList; let j = index; trackBy: trackByIndex"
                                            [value]="opt.statusName">{{ opt.statusName }}</mat-option>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="filter.property != 'status' || filteredTaskStatusTypeList?.length == 0">
                                        <ng-container
                                            *ngIf="filteredUserCallStatusTypeList?.length > 0; else statusFromFilterOptions">
                                            <mat-option
                                                *ngFor="let opt of filteredUserCallStatusTypeList; let j = index; trackBy: trackByValue"
                                                [value]="opt.Status">{{ opt.Status }}</mat-option>
                                        </ng-container>
                                        <ng-template #statusFromFilterOptions>
                                            <mat-option
                                                *ngFor="let item of (filter._filteredOptions || filter.options); trackBy: trackByValue"
                                                [value]="item.value">{{ item.viewValue || item.value }}</mat-option>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-container>

                            <ng-container
                                *ngIf="filter.property =='stage' || filter.name =='Deal Stage' || filter.name == 'Stage' || filter.name == 'Stage Name' || filter.property == 'b.status_name' ||filter.property =='a.stage' || filter.property =='b.statusName'">
                                <mat-option *ngFor="let opt of filteredlDealStatusTypeList; let i=index;"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='tagName'">
                                <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index;"
                                    [value]="opt.statusName">
                                    {{opt.statusName}}
                                </mat-option>
                            </ng-container>


                            <ng-container
                                *ngIf="filter.property =='statusName' || filter.property =='c.status_name' || filter.name =='Status Name' || filter.name =='Life Stage' || filter.name =='Lead Status'">
                                <mat-option
                                    *ngFor="let opt of filtereddropdownTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>


                            <ng-container *ngIf="filter.property =='sourceName'
                                ||filter.property =='g.source_name'
                                ||filter.name =='Source Name'||filter.name =='Lead Source'">
                                <mat-option *ngFor="let opt of filteredLeadSourceTypeList; let i=index;"
                                    [value]="opt.sourceName">
                                    {{opt.sourceName}}
                                </mat-option>
                            </ng-container>


                            <ng-container
                                *ngIf="filter.name == 'Owner'
                                || filter.name == 'Created By'
                                  || filter.name == 'Updated By'
                                || filter.property == 'a.owner_id'
                                || filter.property == 'ownerEmail'
                                || filter.property == 'dealsOwner'
                                || filter.property == 'createdBy'
                                || filter.property == 'created_by'
                                || filter.property == 'a.created_by'|| filter.property == 'a.user_name' || filter.property == 'u.user_name'">


                                <ng-container *ngIf="userDropDownType != 0">
                                    <mat-option *ngFor="let opt of filtereduserTypeList; let i=index;"
                                        [value]="opt.email">{{opt.email}}</mat-option>
                                </ng-container>
                                <ng-container *ngIf="userDropDownType == 0">
                                    <mat-option *ngFor="let opt of filtereduserSolrTypeList; let i=index;"
                                        [value]="opt.originalEmail || opt.email">{{opt.email}}</mat-option>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="filter.name =='Type of Service'">
                                <mat-option
                                    *ngFor="let opt of filteredPayemntTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.name">{{opt.name}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.name =='Activity Type'">
                                <mat-option *ngFor="let opt of filteredActivityTypeList; let i=index;"
                                    [value]="opt.activityType">
                                    {{opt.activityType}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='tracker'">
                                <mat-option *ngFor="let opt of filteredTrackerTypeList; let i=index;"
                                    [value]="opt.trackerName">
                                    {{opt.trackerName}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='priority'">
                                <mat-option *ngFor="let opt of filteredPriorityTypeList; let i=index;"
                                    [value]="opt.statusName">
                                    {{opt.statusName}}
                                </mat-option>
                            </ng-container>



                            <ng-container *ngIf="filter.property =='industryType'">
                                <mat-option *ngFor="let opt of filteredindustryTypeList; let i=index;"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='businessType'">
                                <mat-option *ngFor="let opt of filteredBusinessTypeList; let i=index;"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>

                            <ng-container
                                *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                <mat-option *ngFor="let opt of filteredWarehouseTypeList; let i=index;"
                                    [value]="opt.name">{{opt.name}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                <mat-option *ngFor="let opt of filteredsupplierTypeList; let i=index;"
                                    [value]="opt.name">{{opt.name}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="shouldUseInlineOptions(filter)">
                                <mat-option [disabled]="item.value=='disabled1'"
                                    *ngFor="let item of (filter._filteredOptions || filter.options); trackBy: trackByValue"
                                    [value]="item.value">{{item.viewValue || item.value}}</mat-option>
                            </ng-container>
                        </mat-select>

                        <!-- Single Select Logic -->
                        <mat-select [compareWith]="compareOption" [disableOptionCentering]="true"
                            [(ngModel)]="selectedValues[i]" (selectionChange)="filterColumn($event,i,filter.type)"
                            *ngIf="filter.type == 'select'">
                            <ngx-mat-select-search *ngIf="showSearchForFilter(filter)" [formControl]="filterSearchControls[i]" placeholderLabel="Search"
                                noEntriesFoundLabel="No results found">
                            </ngx-mat-select-search>
                            <mat-option value="ALL">(ALL)</mat-option>
                            <ng-container
                                *ngIf="!url.includes('whatsAppBotFlows') && !url.includes('leadMeetingSummaryReport') && !url.includes('botRepliesList') && !url.includes('expenseCategories') && !url.includes('posPurchase') && !url.includes('holidays')">
                                <ng-container *ngIf="filter.property == 'a.status' || filter.name == 'Status'">
                                    <ng-container
                                        *ngIf="filter.property == 'status' && filteredTaskStatusTypeList?.length > 0">
                                        <mat-option *ngFor="let opt of filteredTaskStatusTypeList; let k = index"
                                            [value]="opt.statusName">{{ opt.statusName }}</mat-option>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="filter.property != 'status' || filteredTaskStatusTypeList?.length == 0">
                                        <ng-container
                                            *ngIf="filteredUserCallStatusTypeList?.length > 0; else statusSingleFromOptions">
                                            <mat-option
                                                *ngFor="let opt of filteredUserCallStatusTypeList; let k = index"
                                                [value]="opt.Status">{{ opt.Status }}</mat-option>
                                        </ng-container>
                                        <ng-template #statusSingleFromOptions>
                                            <mat-option *ngFor="let item of (filter._filteredOptions || filter.options)"
                                                [value]="item.value">{{
                                                item.viewValue || item.value }}</mat-option>
                                        </ng-template>
                                    </ng-container>
                                </ng-container>
                            </ng-container>


                            <ng-container
                                *ngIf="filter.property =='statusName' || filter.name =='Status Name' || filter.name =='Life Stage'">
                                <mat-option
                                    *ngFor="let opt of filtereddropdownTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='sourceName'||filter.name =='Source Name'">
                                <mat-option
                                    *ngFor="let opt of filteredLeadSourceTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.sourceName">
                                    {{opt.sourceName}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='tagName'">
                                <mat-option *ngFor="let opt of filteredtagsTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.statusName">
                                    {{opt.statusName}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='stage' || filter.name =='Deal Stage'">
                                <mat-option
                                    *ngFor="let opt of filteredlDealStatusTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.statusName">
                                    {{opt.statusName}}
                                </mat-option>
                            </ng-container>



                            <ng-container
                                *ngIf="filter.property == 'ownerEmail' || filter.name == 'Owner' || filter.name == 'Created By'  || filter.name == 'Updated By' || filter.property == 'createdBy' || filter.property == 'created_by' || filter.property == 'a.created_by' || filter.property == 'a.user_name' || filter.property == 'u.user_name'">

                                <ng-container *ngIf="userDropDownType != 0">
                                    <mat-option
                                        *ngFor="let opt of filtereduserTypeList; let i=index; trackBy: trackByIndex"
                                        [value]="opt.email">{{opt.email}}</mat-option>
                                </ng-container>
                                <ng-container *ngIf="userDropDownType == 0">
                                    <mat-option
                                        *ngFor="let opt of filtereduserSolrTypeList; let i=index; trackBy: trackByIndex"
                                        [value]="opt.originalEmail || opt.email">{{opt.email}}</mat-option>
                                </ng-container>
                            </ng-container>

                            <ng-container *ngIf="filter.name =='Activity Type'">
                                <mat-option
                                    *ngFor="let opt of filteredActivityTypeList; let i=index; trackBy: trackByIndex"
                                    [value]="opt.activityType">
                                    {{opt.activityType}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='tracker'">
                                <mat-option *ngFor="let opt of filteredTrackerTypeList; let i=index;"
                                    [value]="opt.trackerName">
                                    {{opt.trackerName}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='priority'">
                                <mat-option *ngFor="let opt of filteredPriorityTypeList; let i=index;"
                                    [value]="opt.statusName">
                                    {{opt.statusName}}
                                </mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='industryType'">
                                <mat-option *ngFor="let opt of filteredindustryTypeList; let i=index;"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>

                            <ng-container
                                *ngIf="filter.property =='warehouseName' || filter.property == 'warehouse' || filter.name == 'Location'">
                                <mat-option *ngFor="let opt of filteredWarehouseTypeList; let i=index;"
                                    [value]="opt.name">{{opt.name}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='supplier' || filter.name == 'Suppliers'">
                                <mat-option *ngFor="let opt of filteredsupplierTypeList; let i=index;"
                                    [value]="opt.name">{{opt.name}}</mat-option>
                            </ng-container>

                            <ng-container *ngIf="filter.property =='businessType'">
                                <mat-option *ngFor="let opt of filteredBusinessTypeList; let i=index;"
                                    [value]="opt.statusName">{{opt.statusName}}</mat-option>
                            </ng-container>


                            <ng-container *ngIf="shouldUseInlineOptions(filter)">
                                <mat-option [disabled]="item.value=='disabled1'"
                                    *ngFor="let item of (filter._filteredOptions || filter.options); trackBy: trackByValue"
                                    [value]="item.value">{{item.viewValue || item.value}}</mat-option>
                            </ng-container>
                        </mat-select>

                        <!-- Input Types -->
                        <input [autocomplete]="'off'" #myText trim="blur"
                            (keyup)="filterColumnText($event,i,filter.modelValue)" (keydown)="blockColon($event)"
                            (keypress)="restrictNumbers($event, filter)" (paste)="onPaste($event,i)"
                            *ngIf="filter.type != 'multiSelect' && filter.type != 'multiselect' && filter.type != 'select' && filter.type != 'time'"
                            matInput [(ngModel)]="filter.modelValue" placeholder="{{filter.name | uppercase}}">

                        <div *ngIf="filter.type == 'time'" class="time-picker-container">
                            <input matInput [(ngModel)]="filter.modelValue" style="display: none;">
                            <mat-select placeholder="HH" [(ngModel)]="timeValues[i].hh"
                                (selectionChange)="onTimeChange(i, filter)">
                                <mat-option *ngFor="let h of hoursList" [value]="h">{{h}}</mat-option>
                            </mat-select>
                            <span class="time-separator">:</span>
                            <mat-select placeholder="MM" [(ngModel)]="timeValues[i].mm"
                                (selectionChange)="onTimeChange(i, filter)">
                                <mat-option *ngFor="let m of minutesList" [value]="m">{{m}}</mat-option>
                            </mat-select>
                            <mat-select class="ampm-select" [(ngModel)]="timeValues[i].ampm"
                                (selectionChange)="onTimeChange(i, filter)">
                                <mat-option *ngFor="let a of ampmList" [value]="a">{{a}}</mat-option>
                            </mat-select>
                        </div>
                    </mat-form-field>

                    <!-- Date Range Selection -->
                    <div [formGroup]="filtersForm"
                        *ngIf="(!columns || !columns[i] || columns[i].visible) && filter.type == 'date'">
                        <mat-form-field appearance="outline" class="premium-field">
                            <mat-label>{{filter.name | uppercase}}</mat-label>
                            <mat-icon *ngIf="type != 2" matPrefix color="primary">calendar_today</mat-icon>
                            <mat-date-range-input [formGroup]="filtersForm.get('ranges')['controls'][i]"
                                [rangePicker]="picker">
                                <input [autocomplete]="'off'" (dateChange)="start($event,'start',i)" matStartDate
                                    formControlName="start" placeholder="From">
                                <input [autocomplete]="'off'" (dateChange)="end($event,'end',i)" matEndDate
                                    formControlName="end" placeholder="To">
                            </mat-date-range-input>
                            <button mat-icon-button matSuffix *ngIf="hasDateValue(i)"
                                (click)="clearDateRange(i, $event)" aria-label="Clear">
                                <mat-icon>close</mat-icon>
                            </button>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    </div>
                </ng-container>
            </ng-container>
        </div>

    </div>
    <!-- FOOTER -->
    <div class="filter-footer" [class.type2]="type == 2">
        <!-- FOOTER TYPE 2 (Gray Strip) -->
        <div *ngIf="type == 2" class="footer-buttons-type2">
            <button class="btn-type2" [disabled]="searchTerm == undefined" (click)="resetFilters()"
                [attr.guide]="'btn-lead-view-reset' + '__' + sanitizeUrl(url)">
                <span>Reset</span>
            </button>
            <button class="btn-type2" [disabled]="searchTermPresent" (click)="searchFilter()"
                [attr.guide]="'btn-lead-view-search' + '__' + sanitizeUrl(url)">
                <span>Search</span>
            </button>
            <button *ngIf="!url.includes('createCampaignTemplate')" class="btn-type2" (click)="callclosepopup()"
                [attr.guide]="'btn-lead-view-close' + '__' + sanitizeUrl(url)">
                <span>Close</span>
            </button>
        </div>

        <!-- FOOTER TYPE 1 (Modern Design) -->
        <div *ngIf="type != 2" class="footer-buttons-type1">
            <button class="btn btn-outline" [disabled]="searchTerm == undefined" matTooltip="Reset Filters"
                (click)="resetFilters()" [attr.guide]="'btn-lead-view-reset' + '__' + sanitizeUrl(url)">
                <mat-icon>restart_alt</mat-icon>
                <span>Reset</span>
            </button>
            <button *ngIf="!url.includes('createCampaignTemplate')" class="btn btn-outline" matTooltip="Close Panel"
                (click)="callclosepopup()" [attr.guide]="'btn-lead-view-close' + '__' + sanitizeUrl(url)">
                <mat-icon>close</mat-icon>
                <span>Close</span>
            </button>
            <button class="btn btn-primary" [disabled]="searchTermPresent" matTooltip="Apply Filters"
                (click)="searchFilter()" [attr.guide]="'btn-lead-view-search' + '__' + sanitizeUrl(url)">
                <mat-icon>search</mat-icon>
                <span>Search</span>
            </button>
        </div>
    </div>
</div>